<template>
  <div>
    <ButtonBack class="mb_m"/>

    <input-email />
    <input-password />
    <input-tel />
    <input-name />
    <input-birth-day />
    <input-country />
    <input-prefecture />
    <input-address />
    <input-admin />
    <slot></slot>
  </div>
</template>

<script>
import InputEmail from '@/components/User/InputEmail'
import InputPassword from '@/components/User/InputPassword'
import InputTel from '@/components/User/InputTel'
import InputName from '@/components/User/InputName'
import InputBirthDay from '@/components/User/InputBirthDay'
import InputCountry from '@/components/User/InputCountry'
import InputPrefecture from '@/components/User/InputPrefecture'
import InputAddress from '@/components/User/InputAddress'
import InputAdmin from '@/components/User/InputAdmin'
import ButtonBack from '@/components/ButtonBack'

export default {
  components: {
    InputEmail,
    InputPassword,
    InputTel,
    InputName,
    InputBirthDay,
    InputCountry,
    InputPrefecture,
    InputAddress,
    InputAdmin,
    ButtonBack
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
